export { BottomInfo } from './BottomInfo';
